const arJSON = {
    // NAVBAR
    "Home":"Inicio",
    "Users":"Asesores",
    "User1":"Mis asesores",
    "User2":"Crear asesor",
    "Advanced": "Avanzado",
    "Chat":"Chat",
    "Help":"Ayuda",
    "MyCount": "Mi cuenta",
    "Integrations": "Integraciones",
    "Potenciate": "Potenciate",
    "Logout": "Cerrar sesión",
    "Synchronization": "Sincronización",
    "Billings": "Facturación",
    "Reviews": "Reseñas",
};

export default arJSON;